import {
  LayoutDashboard, FileText, Files, Settings, Search,
  BarChart3, Calendar, MessageSquare, LogOut, X,
  ExternalLink, Image
} from 'lucide-react';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { id: 'posts', label: 'Posts', icon: FileText },
  { id: 'pages', label: 'Pages', icon: Files },
  { id: 'media', label: 'Media', icon: Image },
  { id: 'bookings', label: 'Bookings', icon: Calendar },
  { id: 'messages', label: 'Messages', icon: MessageSquare },
  { id: 'seo', label: 'SEO', icon: Search },
  { id: 'tracking', label: 'Tracking', icon: BarChart3 },
  { id: 'settings', label: 'Settings', icon: Settings },
];

export const Sidebar = ({ activeMenu, setActiveMenu, onLogout, sidebarOpen, setSidebarOpen }) => (
  <>
    {sidebarOpen && (
      <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
    )}
    <aside data-testid="admin-sidebar" className={`fixed top-0 left-0 h-full w-64 bg-[#1e1e1e] text-white z-50 transform transition-transform duration-200 lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
      <div className="p-4 border-b border-gray-700 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-primary rounded flex items-center justify-center">
            <span className="font-bold text-sm">13</span>
          </div>
          <span className="font-semibold">13cabsbook</span>
        </div>
        <button className="lg:hidden text-gray-400 hover:text-white" onClick={() => setSidebarOpen(false)}>
          <X className="w-5 h-5" />
        </button>
      </div>
      <nav className="p-2 flex-1 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 140px)' }}>
        {menuItems.map((item) => (
          <button
            key={item.id}
            data-testid={`sidebar-${item.id}`}
            onClick={() => { setActiveMenu(item.id); setSidebarOpen(false); }}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-colors ${
              activeMenu === item.id 
                ? 'bg-primary text-white' 
                : 'text-gray-300 hover:bg-gray-800 hover:text-white'
            }`}
          >
            <item.icon className="w-5 h-5" />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
      <div className="p-4 border-t border-gray-700">
        <a href="https://13cabsbook.com.au" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-white mb-3 text-sm">
          <ExternalLink className="w-4 h-4" /> View Site
        </a>
        <button onClick={onLogout} className="w-full flex items-center gap-3 px-4 py-2 text-gray-400 hover:text-red-400 transition-colors" data-testid="admin-logout">
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  </>
);
